import React from 'react';

interface JudgeRulesDialogInterface {
    closeDialog: any;
};

function JudgeRulesDialog({closeDialog}: JudgeRulesDialogInterface) {
    const closeIcon = require("../images/close.png");
    const judgeHammer = require("../images/judgeHammerBlack.png");

    const handleClose = () => {
        closeDialog()
    }

    return (
        <div className="judgeRulesDialogWrapper">
            <div className="dialogTop">
                <div className="dialogCloseWrapper" tabIndex={0} onClick={handleClose} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleClose();
                    }
                }}>
                    <img className="dialogCloseIcon" src={closeIcon} alt="close"/>
                </div>
            </div>
            <div className="judgeRulesDialogBottom">
                <div className="judgeRulesDialogRulesTitle">YOU ARE THE JUDGE</div>
                <img className="judgeRulesDialogJudgeHammerIcon" src={judgeHammer} alt="judge"/>
                <p className="judgeRulesDialogRule">Please wait as players pick submissions. Then you will choose the best karma for the red card. Winner gets +1 point.</p>
            </div>
        </div>
    );
};

export default JudgeRulesDialog;